import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import RefreshIcon from "@mui/icons-material/Refresh";
import axiosInstance from "../../Axios";
import useAuth from "../../contexts/UserContext.tsx";

export const ReportsTable = ({ reportReload, setReportReload }) => {
  const [reports, setReports] = useState();
  const [districts, setDistricts] = useState();
  const [refreshDisabled, setRefreshDisabled] = useState(false);
  const { user } = useAuth();

  const columns = [
    { id: "report_id", label: "Report ID" },
    { id: "month", label: "Month-Year" },
    { id: "type", label: "Type" },
    { id: "distict", label: "District" },
    { id: "school_types", label: "School Types" },
    { id: "status", label: "Status" },
    { id: "actions", label: "Actions" },
  ];

  const navigate = useNavigate();

  const getReports = async () => {
    try {
      const res = await axiosInstance.get(
        `/getAllReportDetails?auth_token=${user.auth_token}`
      );
      setReports(res.data.data.reports);
    } catch (err) {
      alert(err.message);
    }
  };

  const getAllDistrcts = async () => {
    try {
      const res = await axiosInstance.get(
        `getDistricts?auth_token=${user.auth_token}`
      );
      setDistricts(res.data.data.districts);
    } catch (err) {
      alert(err.message);
    }
  };

  const refreshClicked = () => {
    setRefreshDisabled(true);
    setReportReload(true);
    setTimeout(() => {
      setRefreshDisabled(false);
    }, 5000);
  };

  useEffect(() => {
    getReports();
    getAllDistrcts();

    if (reportReload) {
      setReportReload(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportReload]);

  return (
    <TableContainer component={Paper} className="table m-1 mt-4">
      <Table id="summary" className="mb-0">
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell key={column.id}>
                {column.label}
                {column.id === "status" && (
                  <RefreshIcon
                    disabled={refreshDisabled}
                    onClick={() => !refreshDisabled && refreshClicked()}
                    className="ml-2"
                    style={{
                      cursor: refreshDisabled ? "not-allowed" : "pointer",
                      color: refreshDisabled ? "grey" : "black",
                    }}
                  />
                )}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {reports &&
            districts &&
            reports.map((report) => {
              return (
                <TableRow key={report.id}>
                  <TableCell>{report.id}</TableCell>
                  <TableCell>{`${report.month}-${report.year}`}</TableCell>
                  <TableCell>
                    {report.type.charAt(0).toUpperCase() + report.type.slice(1)}
                  </TableCell>
                  <TableCell>
                    {
                      districts.find(
                        (district) => district.dist_id === report.district_id
                      ).dist_name
                    }
                  </TableCell>
                  <TableCell>
                    {report.school_types.replaceAll("'", " ")}
                  </TableCell>
                  <TableCell>{report.status}</TableCell>
                  <TableCell>
                    <button
                      onClick={() => navigate(`/report/${report.id}`)}
                      className="bg-sky-500 rounded p-2 text-white hover:bg-sky-700"
                    >
                      Open Report
                    </button>
                  </TableCell>
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
